import type { IconName } from '@/components/common/Icon';
import { MEDIA_IMAGE_CONTENT_TYPES } from '@/constants/media';

export const PRE_VISIT_QUESTION_TYPE = {
  sectionHeading: 'section_heading',
  shortText: 'short_text',
  longText: 'long_text',
  yesNo: 'yes_no',
  singleChoice: 'single_choice',
  multipleChoice: 'multiple_choice',
  number: 'number',
  date: 'date',
  photos: 'photos',
} as const;

export type PreVisitQuestionType =
  (typeof PRE_VISIT_QUESTION_TYPE)[keyof typeof PRE_VISIT_QUESTION_TYPE];

export const PRE_VISIT_QUESTION_TYPE_ORDER: PreVisitQuestionType[] = [
  PRE_VISIT_QUESTION_TYPE.sectionHeading,
  PRE_VISIT_QUESTION_TYPE.shortText,
  PRE_VISIT_QUESTION_TYPE.longText,
  PRE_VISIT_QUESTION_TYPE.yesNo,
  PRE_VISIT_QUESTION_TYPE.singleChoice,
  PRE_VISIT_QUESTION_TYPE.multipleChoice,
  PRE_VISIT_QUESTION_TYPE.number,
  PRE_VISIT_QUESTION_TYPE.date,
  PRE_VISIT_QUESTION_TYPE.photos,
];

export const PRE_VISIT_CHOICE_QUESTION_TYPES: PreVisitQuestionType[] = [
  PRE_VISIT_QUESTION_TYPE.singleChoice,
  PRE_VISIT_QUESTION_TYPE.multipleChoice,
];

export function isPreVisitChoiceQuestionType(questionType: PreVisitQuestionType): boolean {
  return PRE_VISIT_CHOICE_QUESTION_TYPES.includes(questionType);
}

export const PRE_VISIT_QUESTION_TYPE_ICON: Record<PreVisitQuestionType, IconName> = {
  section_heading: 'Heading2',
  short_text: 'Edit',
  long_text: 'ClipboardList',
  yes_no: 'CheckCircle',
  single_choice: 'ClipboardCheck',
  multiple_choice: 'ListOrdered',
  number: 'Hash',
  date: 'Calendar',
  photos: 'Image',
};

export const PRE_VISIT_PHOTO_MAX_SIZE_BYTES = 15 * 1024 * 1024;
export const PRE_VISIT_PHOTOS_PER_QUESTION_MAX = 10;
export const ALLOWED_PRE_VISIT_PHOTO_CONTENT_TYPES: readonly string[] = MEDIA_IMAGE_CONTENT_TYPES;
